


































import Vue from 'vue'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import type { ResumoDaVenda, NotaDaVenda } from '@/models'

export default Vue.extend({
	name: 'AcoesDaGridDePedidos',
	props: {
		params: {
			type: Object as () => any,
			required: true,
		},
	},
	data() {
		return {
			reenviando: false,
		}
	},
	computed: {
		venda(this: any): ResumoDaVenda {
			return this.params?.data as ResumoDaVenda
		},

		podeCancelarPedidoGlobal(): boolean {
			return !!UserLoginStore.permiteRegraDeNegocio('pode-cancelar-pedidos')
		},

		deveVerificarProdutos(this: any): boolean {
			return !!this.venda.deveVerificarProdutos
		},

		isDevolucaoPedidos(this: any): boolean {
			return !!this.venda.isDevolucaoPedidos
		},

		ultimaNota(this: any): NotaDaVenda | null {
			const notas = this.venda.notas || []
			if (!notas.length) return null
			return notas[notas.length - 1]
		},

		temNotaAtiva(this: any): boolean {
			if (!this.ultimaNota) return false
			return this.ultimaNota.cstat !== '101' && this.ultimaNota.cstat !== '102'
		},

		mostrarVerificarProdutos(this: any): boolean {
			if (this.envioPendente) return false
			return (
				this.venda.situacaoPedido === 'Pendente' &&
				this.deveVerificarProdutos
			)
		},

		mostrarCancelarPedido(this: any): boolean {
			if (this.envioPendente) return false
			if (!this.podeCancelarPedidoGlobal) return false
			if (this.venda.situacaoPedido === 'Devolvido') return false
			if (this.venda.temDevolucao) return false
			if (this.venda.situacao === 'Cancelada') return false
			if (this.isBloqueadoPorNotaImportada(this.venda)) return false
			if (!this.podeCancelarPedidoMarketplace(this.venda)) return false
			if (this.venda.modalidadeDeVenda && this.venda.modalidadeDeVenda.origem === 'Vitrine Virtual') return false
			return true
		},

		tipoCancelarPedido(this: any): string {
			if (this.venda.notas?.length && this.temNotaAtiva) {
				return 'cancelar-com-motivo-fiscal'
			}
			return 'cancelar-com-motivo'
		},

		mostrarCancelarNota(this: any): boolean {
			if (this.envioPendente) return false
			if (!this.podeCancelarPedidoGlobal) return false
			if (!this.venda.notas?.length) return false
			if (this.venda.isPedidoMarketplace) return false
			if (!this.podeCancelarNotas(this.venda.notas)) return false
			if (this.venda.temDevolucao) return false
			if (this.venda.situacao === 'Cancelada') return false
			if (this.isBloqueadoPorNotaImportada(this.venda)) return false
			if (!this.validaSituacao(this.venda)) return false
			if (this.venda.modalidadeDeVenda && this.venda.modalidadeDeVenda.origem === 'Vitrine Virtual') return false
			return true
		},

		mostrarDevolverPedido(this: any): boolean {
			if (this.envioPendente) return false
			if (this.venda.situacaoPedido === 'Devolvido') return false
			if (this.venda.situacaoPedido === 'Cancelado') return false
			if (this.venda.tipoDeTransacao === 'Devolução') return false
			if (!this.podeDevolverPedido()) return false
			if (this.isBloqueadoPorNotaImportada(this.venda)) return false
			return true
		},

		mostrarEditarColeta(this: any): boolean {
			if (this.envioPendente) return false
			return (
				this.venda.situacaoPedido === 'Aguardando Coleta' ||
				this.venda.situacaoPedido === 'Coletado'
			)
		},

		mostrarEditarSituacao(this: any): boolean {
			if (this.envioPendente) return false
			const v = this.venda
			const isDevolucaoPedido = window.location.pathname.includes('/devolucao-pedidos')

			if (v.situacaoPedido === 'Aguardando Coleta' || v.situacaoPedido === 'Coletado' || v.situacaoPedido === 'Devolvido' 
			|| this.venda.pedido.situacao === 'Entregue' || this.venda.pedido.situacao === 'Cancelado' || isDevolucaoPedido) return false

			const modalidade = v.informacoesDeTransporte?.modalidadeDeFrete
			const permiteAlterarComFrete =
				v.pontoDeVenda?.loja?.configuracaoDaLoja
					?.permiteAlterarSituacaoPedidoComFrete

			if (modalidade === 'Sem Frete') return true
			if (modalidade !== 'Sem Frete' && permiteAlterarComFrete) return true

			return false
		},

		envioPendente(this: any): boolean {
			return !!this.venda.envioPedidoParaApiDeIntegracaoPendente
		},

		mostrarReenviarPedidoParaApi(this: any): boolean {
			return this.envioPendente
		},
	},

	methods: {
		emitAcao(this: any, acao: string) {
			this.$emit('acao', {
				acao,
				dados: this.venda,
			})
		},

		reenviarPedidoParaApi(this: any) {
			this.reenviando = true
			this.$emit('ocultar-tooltip')
			this.emitAcao('reenviar-pedido-para-api')
		},

		mostrarTooltipDoReenvio(this: any, evento: MouseEvent) {
			this.$emit('mostrar-tooltip', {
				elemento: evento.currentTarget,
				titulo: 'Reenviar pedido',
				descricao: 'Tenta lançar novamente o pedido na API de integração',
			})
		},

		podeCancelarNotas(notas: NotaDaVenda[]): boolean {
			if (!notas.length) return true
			return notas.some(
				n => n.cstat !== '101' && n.cstat !== '102',
			)
		},

		podeCancelarPedidoMarketplace(venda: ResumoDaVenda): boolean {
			if (!venda.isPedidoMarketplace || !venda.pedido) return true

			const situacoesCancelaveis = [
				'Pendente',
				'Faturado',
				'Devolvido',
				'Aguardando Coleta',
				'Em Separação',
				'Pedido pronto para Retirada na Loja',
			]

			return situacoesCancelaveis.includes(venda.pedido.situacao)
		},

		validaSituacao(venda: ResumoDaVenda): boolean {
			if (!venda.situacaoPedido) return false
			return ![
				'Pendente',
				'Entregue',
				'Cancelado',
				'Devolvido',
			].includes(venda.situacaoPedido)
		},

		podeDevolverPedido(): boolean {
			const permissoes = UserLoginStore.perfil?.permissoes
			if (!permissoes) return false
			return permissoes.some(p =>
				p.includes('pode-devolver-pedido'),
			)
		},

		isBloqueadoPorNotaImportada(venda: ResumoDaVenda): boolean {
			return !!(venda.pedido && venda.pedido.notaImportada)
		},
	},
})
